import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useNavigate } from "react-router-dom";

const SpecialitiesSection = ({ categoriesData }) => {
  const navigate = useNavigate();

  return (
    <section className="w-full">
      <Swiper
        grabCursor
        breakpoints={{
          0: { slidesPerView: 3.2, spaceBetween: 8 },
          480: { slidesPerView: 4, spaceBetween: 8 },
          768: { slidesPerView: 5, spaceBetween: 10 },
          900: { slidesPerView: 6, spaceBetween: 12 },
          1150: { slidesPerView: 8, spaceBetween: 16 },
        }}
        className="specialities-swiper"
      >
        {categoriesData.map((item) => (
          <SwiperSlide key={item.id} className="h-full">
            <div
              onClick={() => navigate(`/doctors?specialty=${item.title}`)}
              className="
               select-none
                h-[118px]
                sm:h-[145px]
                lg:h-[150px]
                w-full

                bg-white
                rounded-[16px]
                sm:rounded-[20px]
                lg:rounded-[24px]

                flex
                flex-col
                items-center
                justify-center

                px-2
                sm:px-3
                cursor-pointer
                transition-all
                duration-300
                hover:-translate-y-1
                hover:shadow-md
              "
            >
              <div
                className="
                  w-[56px] h-[56px]
                  sm:w-[62px] sm:h-[62px]
                  lg:w-[66px] lg:h-[66px]

                  rounded-full
                  bg-[#F5F5F5]

                  flex
                  items-center
                  justify-center

                  shrink-0
                "
              >
                <img
                  src={item.thumb}
                  alt={item.title}
                  className="
                    w-[34px] h-[34px]
                    sm:w-[38px] sm:h-[38px]
                    lg:w-[40px] lg:h-[40px]
                    object-contain
                  "
                />
              </div>

              <div className="mt-2 lg:mt-4 h-[20px] sm:h-[22px] flex items-start justify-center w-full">
                <span
                  className="
      text-center
      text-[11px]
      sm:text-[12px]
      lg:text-[13px]
      font-medium
      leading-5
      text-[#444]/90
      line-clamp-1
      break-words
      px-1
    "
                >
                  {item.title}
                </span>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default SpecialitiesSection;
